import React from "react";

import RouteBoardColumn from "./RouteBoardColumn";
import { useRouteBuilder } from "../../../context/RouteBuilderContext";
import { AddRouteButton } from "./RouteActions";
import { groupBuilderRoutes } from "../../../lib/builderRouteGroups";

export default function ListBoardView() {
  const { session, selectedRouteId, setSelectedRouteId, visibleRoutes } =
    useRouteBuilder();
  if (!session) return null;
  const groups = groupBuilderRoutes(visibleRoutes, session);

  return (
    <div
      className="flex h-full min-h-0 w-full flex-1 gap-4 overflow-x-auto overflow-y-hidden bg-slate-100/80 p-3"
      data-testid="list-board-view"
    >
      {groups.map((group) => (
        <div
          key={group.key}
          className="flex h-full shrink-0 flex-col gap-2"
          data-testid={`builder-group-${group.key}`}
        >
          {group.label ? (
            <div
              className="shrink-0 rounded-lg bg-slate-200/80 px-3 py-1 text-xs font-semibold text-slate-700"
              data-testid={`builder-group-header-${group.key}`}
            >
              {group.label}
            </div>
          ) : null}
          <div className="flex min-h-0 flex-1 gap-3">
            {group.routes.map((route) => (
              <RouteBoardColumn
                key={route.id}
                route={route}
                reorderable
                selected={selectedRouteId === route.id}
                onSelect={() => setSelectedRouteId(route.id)}
              />
            ))}
          </div>
        </div>
      ))}
      <div className="flex h-full w-[220px] shrink-0 items-center justify-center rounded-xl border border-dashed border-slate-300 bg-white/60">
        <AddRouteButton />
      </div>
    </div>
  );
}
